import * as Yup from "yup";
import { dateToyyyyMMdd } from "../../../../util/date";
import { AdresseDTO } from "../../../../interfaces/adresse";
import { Adresse } from "../../../../interfaces/schema";
import { validationMessages } from "../../../../constants/validation";
import { YupAdresseGeneric } from "../../../../util/yup";
import { getPatchOperations } from "../../../../util/form";
import { PersonAltKontaktAdresseDTO } from "../../../../interfaces/formDto";
export const personAltFakturaAdresseFormConfig = (
  personId: string,
  betalingsadresseId?: string,
  adresse?: Adresse,
): FormConfig<Form, PersonAltKontaktAdresseDTO> => {
  const query = `person/${personId}/betalingsadresser`;
  const queryWId = query + `/${betalingsadresseId}`;
  const requiredMsg = validationMessages.required;
  return {
    title: "alternativ faktureringsadresse",
    get: queryWId,
    form: [
      {
        component: "boolean",
        id: "type",
        label: "Fra DAR?",
        initialValue: adresse ? !!adresse.darAdresseId : true,
      },
      {
        component: "adresse",
        id: "adresseDar",
        initialValue: "",
        label: "Adresse",
        isRequired: true,
        conditionalHidden: ({ values }) => !values.type,
      },
      {
        component: "andenAdresse",
        id: "andenAdresse",
        label: "Adresse",
        initialValue: adresse
          ? adresse
          : {
              adresselinie1: "",
              adresselinie2: "",
              postnummer: "",
              bynavn: "",
              adresselinie4: "",
              coNavn: "",
              landekode: "",
            },
        conditionalHidden: ({ values }) => values.type,
      },
      {
        component: "datepicker",
        id: "periodeFraDato",
        initialValue: "",
        label: "Startdato",
        isRequired: true,
      },
      {
        component: "datepicker",
        id: "periodeTilDatoInklusiv",
        initialValue: "",
        label: "Slutdato",
      },
      {
        component: "textarea",
        id: "bemaerkning",
        initialValue: "",
        label: "Bemærkninger",
      },
      {
        component: "textinput",
        id: "email",
        initialValue: "",
        label: "Email",
        isRequired: true,
      },
    ],
    validationSchema: Yup.object({
      type: Yup.boolean().required(requiredMsg),
      adresseDar: Yup.object().when("type", {
        is: true,
        then: (shcema) => shcema.required(requiredMsg),
      }),
      andenAdresse: Yup.object().when("type", {
        is: false,
        then: YupAdresseGeneric,
      }),
      periodeFraDato: Yup.date()
        .nullable()
        .required(requiredMsg)
        .test("", "Startdato er efter slutdato", function () {
          if (
            this.parent.periodeTilDatoInklusiv === undefined ||
            this.parent.periodeTilDatoInklusiv === null
          ) {
            return true;
          }
          return (
            this.parent.periodeTilDatoInklusiv >= this.parent.periodeFraDato
          );
        }),
      periodeTilDatoInklusiv: Yup.date().nullable(),
      email: Yup.string()
        .email(validationMessages.validEmail)
        .required(validationMessages.required),
    }),
    post: (values: Form) => {
      const { andenAdresse } = values;
      let body: PersonAltKontaktAdresseDTO;
      const globals = {
        bemaerkning: values.bemaerkning,
        periodeFraDato: dateToyyyyMMdd(values.periodeFraDato),
        periodeTilDatoInklusiv: values.periodeTilDatoInklusiv
          ? dateToyyyyMMdd(values.periodeTilDatoInklusiv)
          : "9999-12-31",
        email: values.email,
      };
      if (values.type) {
        body = {
          ...globals,
          adresse: values.adresseDar,
        };
      } else {
        body = {
          ...globals,
          adresse: {
            darAdresseId: null,
            ...andenAdresse,
            coNavn: andenAdresse.coNavn ?? null,
            adresselinie2: andenAdresse.adresselinie2 ?? null,
            adresselinie4: andenAdresse.adresselinie4 ?? null,
          },
        };
      }
      return {
        body,
        query,
      };
    },
    patch: (values: Form) => {
      const body: PersonAltKontaktAdresseDTO = {} as PersonAltKontaktAdresseDTO;
      if (values.adresseDar) {
        body.adresse = values.adresseDar;
      } else if (values.andenAdresse) {
        body.adresse = { ...values.andenAdresse, darAdresseId: null };
      }
      if (values.periodeFraDato) {
        body.periodeFraDato = dateToyyyyMMdd(values.periodeFraDato);
      }
      if (values.periodeTilDatoInklusiv) {
        body.periodeTilDatoInklusiv = dateToyyyyMMdd(
          values.periodeTilDatoInklusiv,
        );
      } else if ("periodeTilDatoInklusiv" in values) {
        body.periodeTilDatoInklusiv = "9999-12-31";
      }
      if ("email" in values) {
        body.email = values.email;
      }
      if ("bemaerkning" in values) {
        body.bemaerkning = values.bemaerkning || "";
      }
      return {
        query: queryWId,
        body: JSON.stringify(getPatchOperations(body)),
      };
    },
    delete: () => {
      return {
        query: queryWId,
      };
    },
  };
};

interface Form {
  type: boolean;
  adresseDar: AdresseDTO;
  andenAdresse: AdresseDTO;
  periodeFraDato: Date;
  periodeTilDatoInklusiv: Date;
  bemaerkning: string;
  email: string;
}
